import styled from '@emotion/styled';
import { Row, Col } from 'react-bootstrap';

import CONST from '../constants';
import { Container, Body, Title } from './Common';
import imgIcon1 from '../resources/premium-1.jpg';
import imgIcon2 from '../resources/premium-2.jpg';
import imgIcon3 from '../resources/premium-3.jpg';
import imgIcon4 from '../resources/premium-4.jpg';
import imgIcon5 from '../resources/premium-5.jpg';

const BREAKPOINT_LIMIT = CONST.SCREEN.BREAKPOINT.XL;

const Section = {
    Row: styled(Row)`
        padding: 0;

        @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
            padding: 0 16px;
        }
    `,
    SubTitle: styled.p`
        display: block;
        position: relative;
        margin: 0;
        color: ${CONST.COLOR.THEME};
        font-size: 4vw;
        text-align: center;
        line-height: 1;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            font-size: ${CONST.SCREEN.BREAKPOINT.SM * 0.04}px;
        }

        @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
            font-size: 24px;
            text-align: left;
        }
    `,
    Title: styled.p`
        display: block;
        position: relative;
        margin: 0;
        color: ${CONST.COLOR.THEME};
        font-size: 8vw;
        font-weight: bold;
        line-height: 1.1;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            font-size: ${CONST.SCREEN.BREAKPOINT.SM * 0.08}px;
        }

        @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
            font-size: 48px;
            text-align: left;
        }

        & > span {
            font-size: 12vw;
            vertical-align: middle;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                font-size: ${CONST.SCREEN.BREAKPOINT.SM * 0.12}px;
            }

            @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
                font-size: 75px;
                text-align: left;
            }
        }
    `,
    Text: styled.p`
        display: block;
        position: relative;
        margin: 0;
        color: ${CONST.COLOR.TEXT};
        font-size: 4vw;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            font-size: ${CONST.SCREEN.BREAKPOINT.SM * 0.04}px;
        }

        @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
            font-size: 20px;
        }
    `,
    Image: styled.img`
        width: 100%;
        margin: 2vw 0 6vw;
        border: 1px solid ${CONST.COLOR.THEME};
        z-index: 2;

        @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
            margin: 10px 0 0;
        }
    `,
    Card: ({ color, subTitle, title, icon, texts = [] }) => {
        const Container = styled.div`
            display: inline-block;
            position: relative;
            width: 270px;
            margin: 10px;
            padding: 20px;
            background: ${color};
            border-radius: 5px;
            box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
        `;

        const SubTitle = styled.p`
            display: block;
            position: relative;
            margin: 0;
            color: #fff;
            font-size: 15px;
            line-height: 2;
            text-transform: uppercase;
        `;

        const Title = styled.p`
            display: block;
            position: relative;
            margin: 0;
            color: #fff;
            font-size: 20px;
            font-weight: bold;
        `;

        const Image = styled.img`
            display: inline-block;
            position: relative;
            padding: 5px;
            border: 10px double rgba(255, 255, 255, 0.75);
            border-radius: 50%;
            opacity: 0.75;
        `;

        const Text = styled.p`
            display: block;
            position: relative;
            margin: 0;
            color: #fff;
            font-size: 12px;
            line-height: 1.6;
            text-align: left;

            &::before {
                content: '- ';
                vertical-align: text-bottom;
            }
        `;

        const fragment = [];
        for (const text of texts) {
            fragment.push(<Text>{text}</Text>);
        }

        return (
            <Container>
                <SubTitle>{subTitle}</SubTitle>
                <Title>{title}</Title>
                <Image className="mt-3 mb-3" src={icon} alt="" />
                {fragment}
            </Container>
        );
    },
};

const Premium = () => {
    return (
        <Container>
            <Title textKr="프리미엄" textEng="Premium" />
            <Body className="mt-3 mt-sm-4">
                <Section.Row>
                    <Col xl={3}>
                        <Section.Title style={{ color: CONST.COLOR.THEME_SECONDARY }}>HIGHCUBE</Section.Title>
                        <Section.Title className="text-xl-end">
                            PREMIUM<span>5</span>
                        </Section.Title>
                        <Section.Text className="mt-2 mt-xl-4">고척에 깃발을 꽃다!</Section.Text>
                        <Section.Text>고척동 최초 지식간업센터</Section.Text>
                    </Col>
                    <Col xl={9}>
                        <Row className="justify-content-center">
                            <Section.Card color={CONST.COLOR.THEME} subTitle="Premium 01" title="수준높은 특화설계" icon={imgIcon1} texts={['대규모 어메니티 특화시설(B1)', '서비스 발코니(노대 발코니 미적용)', '쾌적한 스텝형 테라스 설계(16~18F)']} />
                            <Section.Card color={CONST.COLOR.THEME_SECONDARY} subTitle="Premium 02" title="쾌적한 조망과 업무환경" icon={imgIcon2} texts={['지상 2층 ~ 6층 지상 주차장 적용', '지상 6층부터 조망권 특화 사무실 구성', '고척돔, 안양천 등 수려한 도심경관']} />
                            <Section.Card color={CONST.COLOR.THEME} subTitle="Premium 03" title="서울 도심 산업의 앞선 입지" icon={imgIcon3} texts={['경인로 대로변 위치', '약 2,200세대 고척 아이파크 예정', '고척 비전을 흡수하는 중심지']} />
                            <Section.Card color={CONST.COLOR.THEME_SECONDARY} subTitle="Premium 04" title="역세권의 우수한 교통환경" icon={imgIcon4} texts={['1호선 개봉역 약 350m(도보 약분 거리)', 'YBD, G밸리, 마곡 등 입무지구 접근성 우수', '서부간선지하도로 개통']} />
                            <Section.Card color={CONST.COLOR.THEME} subTitle="Premium 05" title="고척 개발 비전의 중심" icon={imgIcon5} texts={['고척 아이파크몰, 코스트코 입점 예정', '구로세무서, 복합청사 등 행정기관 예정', '고척 4구역 재개발, 고척공구상가 재건축 등']} />
                        </Row>
                    </Col>
                </Section.Row>
            </Body>
        </Container>
    );
};

export default Premium;
